module.exports = __webpack_public_path__ + "img/breed.453675d6.svg";